export const csvMimeTypes =
  '.csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, ' +
  'application/x-csv, text/comma-separated-values, text/x-comma-separated-values';

export const excelMimeTypes =
  '.xls, .xlsx, application/vnd.ms-excel, ' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
